import { ConsignmentItemFormValues } from 'features/declaration/consignment-item/models/schema'
import { toConsignmentItemCreate, toConsignmentItemUpdate } from '../models/mapper'
import { createConsignmentItem } from '../api/createConsignmentItem'
import { createConsignmentItemDraft } from '../api/createConsignmentItemDraft'
import { updateConsignmentItem } from '../api/updateConsignmentItem'
import { updateConsignmentItemDraft } from '../api/updateConsignmentItemDraft'
import { ConsignmentItemDetails } from '../models/types'

interface SaveConsignmentItemParameters {
  id: number | null
  houseConsignmentId: number
  isDraft: boolean
  formValues: ConsignmentItemFormValues
}

function useSaveConsignmentItem() {
  const saveConsignmentItem = async ({
    id,
    houseConsignmentId,
    isDraft,
    formValues,
  } : SaveConsignmentItemParameters): Promise<ConsignmentItemDetails> => {
    if (id != null) {
      const data = toConsignmentItemUpdate(houseConsignmentId, formValues)

      return isDraft ? await updateConsignmentItemDraft(id, data) : await updateConsignmentItem(id, data)
    }

    const data = toConsignmentItemCreate(houseConsignmentId, formValues)

    return isDraft ? await createConsignmentItemDraft(data) : await createConsignmentItem(data)
  }

  return {
    saveConsignmentItem,
  }
}

export default useSaveConsignmentItem
